module.exports = __webpack_public_path__ + "static/food-square.aedd07d3.jpg";